<template>
  <v-app>
    <v-main>
      <main-wrap />
    </v-main>
  </v-app>
</template>

<style>
::-webkit-scrollbar {
  display: none;
}

html, body {
  height: 100%;
  width: 100%;
  overflow: hidden ;
}
</style>

<script>
import mainWrap from './views/Main';
export default {
  name: 'App',
  components: {
    mainWrap,
  },
  data: () => ({
  }),
};
</script>

<style>

::-webkit-scrollbar {
  display: none;
}

html, body {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
